import actionTypes from '../common/actionTypes';
import userAPI from './userAPI';

const userActions = {
	resetUser: () => {
		return { type: actionTypes.RESET_USER };
	},
	setUser: (user: UserDetails) => {
		return { type: actionTypes.SET_USER, user };
	},
	fetchUser: (userId: string) => (dispatch: any) => {
		return userAPI.fetchUser(userId)
			.then((user: UserDetails) => {
				dispatch({ type: actionTypes.FETCH_USER, user });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchUserByPolicyId: (policyId: string) => (dispatch: any) => {
		return userAPI.fetchUserByPolicyId(policyId)
			.then((user: UserDetails) => {
				dispatch({ type: actionTypes.FETCH_USER, user });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchReferrerNameByReferralCode: (referralCode: string) => (dispatch: any) => {
		return userAPI.fetchReferrerNameByReferralCode(referralCode)
			.then((referrerName: string) => {
				dispatch({ type: actionTypes.FETCH_REFERRER_NAME_BY_REFERRAL_CODE_SUCCESS, referrerName });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchReferrerNameBySpousalReferralCode: (spousalReferralCode: string) => (dispatch: any) => {
		return userAPI.fetchReferrerNameBySpousalReferralCode(spousalReferralCode)
			.then((referrerName: string) => {
				dispatch({ type: actionTypes.FETCH_REFERRER_NAME_BY_SPOUSAL_REFERRAL_CODE_SUCCESS, referrerName });
			})
			.catch(err => {
				throw err;
			});
	},
	saveUser: (user: UserDetails) => (dispatch: any) => {
		return userAPI.saveUser(user)
			.then((savedUser: UserDetails) => {
				dispatch({ type: actionTypes.SAVE_USER, user: savedUser });
			})
			.catch(err => {
				throw err;
			});
	},
	adminSaveUser: (user: UserDetails) => (dispatch: any) => {
		return userAPI.adminSaveUser(user)
			.then((savedUser: UserDetails) => {
				dispatch({ type: actionTypes.SAVE_USER, user: savedUser });
			})
			.catch(err => {
				throw err; // where does this go?
			});
	},
	updateSoftDeclinedUser: (user: UserDetails, policyId: string) => (dispatch: any) => {
		return userAPI.updateSoftDeclinedUser(user, policyId)
			.then((updatedUser: UserDetails) => {
				dispatch({ type: actionTypes.SAVE_USER, user: updatedUser });
			})
			.catch(err => {
				throw err;
			});
	},
	saveStaff: (user: UserDetails) => (dispatch: any) => {
		return userAPI.saveStaff(user)
			.then((savedUser: UserDetails) => {
				dispatch({ type: actionTypes.SAVE_USER, user: savedUser });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchAdmins: () => (dispatch: any) => {
		return userAPI.fetchAdmins()
			.then((admins: UserDetails) => {
				dispatch({ type: actionTypes.FETCH_ADMINS, admins });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchCustomers: (filterProspects?: boolean) => (dispatch: any) => {
		return userAPI.fetchCustomers(filterProspects)
			.then((customers: UserDetails) => {
				dispatch({ type: actionTypes.FETCH_CUSTOMERS, customers });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchSoftDeclinedCustomers: () => (dispatch: any) => {
		return userAPI.fetchSoftDeclinedCustomers()
			.then((softDeclinedCustomers: SoftDeclinedUserDetailsDto[]) => {
				dispatch({ type: actionTypes.FETCH_SOFT_DECLINED_CUSTOMERS, customers: softDeclinedCustomers});
			})
			.catch(err => {
				throw err;
			});
	},
	clearAdjudicationQueue: () => (dispatch: any) => {
		return userAPI.clearAdjudicationQueue()
			.then(() => {
				dispatch({ type: actionTypes.CLEAR_ADJUDICATION_QUEUE });
			})
			.catch(err => {
				throw err;
			});
	},
	setCustomerNote: (note: CustomerNote) => {
		return { type: actionTypes.SET_CUSTOMER_NOTE, note };
	},
	fetchCustomerNote: (customerId: string, noteId: string) => (dispatch: any) => {
		return userAPI.fetchCustomerNote(customerId, noteId)
			.then((note: any) => {
				dispatch({ type: actionTypes.FETCH_CUSTOMER_NOTE, note });
			})
			.catch(err => {
				throw err;
			});
	},
	fetchCustomerNotes: (customerId: string) => (dispatch: any) => {
		return userAPI.fetchCustomerNotes(customerId)
			.then((notes: any) => {
				dispatch({ type: actionTypes.FETCH_CUSTOMER_NOTES, notes });
			})
			.catch(err => {
				throw err;
			});
	},
	resetCustomerNote: (customerId: string) => {
		return {type: actionTypes.RESET_CUSTOMER_NOTES, customerId};
	},
	resetCustomerAnswerNote: (customerId: string, answerId: string) => {
		return {type: actionTypes.RESET_CUSTOMER_ANSWER_NOTES, customerId, answerId};
	},
	saveCustomerNote: (note: CustomerNote) => (dispatch: any) => {
		return userAPI.saveCustomerNote(note)
			.then((savedNote: any) => {
				dispatch({ type: actionTypes.SAVE_CUSTOMER_NOTE, note: savedNote });
			})
			.catch(err => {
				throw err;
			});
	},
	resetPassword: (userId: string, resetUrl: string) => (dispatch: any) => {
		return userAPI.resetPassword(userId, resetUrl)
			.then((success: boolean) => {  // todo: this should fail at runtime as the return type is not a primitive type
				dispatch({ type: actionTypes.RESET_PASSWORD, success });
			})
			.catch(err => {
				throw err;
			});
	},
	saveRole: (userId: string, roles: string[]) => (dispatch: any) => {
		return userAPI.saveRole(userId, roles)
			.then((test) => {
				dispatch({ type: actionTypes.SAVE_USER_ROLE_SUCCESS, test });
			});
	},

	clearReferrals: (customerId: string) => (dispatch: any) => {
		return dispatch({ type: actionTypes.RESET_CUSTOMER_REFERRALS });
	},
	fetchReferrals: (customerId: string) => (dispatch: any) => {
		return userAPI.fetchReferrals(customerId)
			.then((referrals: CustomerReferralResponse) => {
				dispatch({ type: actionTypes.FETCH_CUSTOMER_REFERRALS_SUCCESS, referrals });
			})
			.catch(err => {
				throw err;
			});
	},
	generateNewReferralCode: (customerId: string) => (dispatch: any) => {
		return userAPI.generateNewReferralCode(customerId)
			.then((referralCode: string) => {
				dispatch({ type: actionTypes.GENERATE_NEW_REFERRALCODE_SUCCESS, referralCode: referralCode });
			})
			.catch(err => {
				throw err;
			});
	},
	setReferralCode: (referralCode: string) => {
		return { type: actionTypes.SET_REFERRALCODE_SUCCESS, referralCode };
	},
	setSpousalReferralCode: (spousalReferralCode: string) => {
		return { type: actionTypes.SET_SPOUSALREFERRALCODE_SUCCESS, spousalReferralCode};
	},
	updateReferralBalance: (customerId: string, referralBalance: number) => (dispatch: any) => {
		return userAPI.updateReferralBalance(customerId, referralBalance)
			.then((referralBalanceResponse: number) => {
				dispatch({ type: actionTypes.UPDATE_REFERAL_BALANCE_SUCCESS, referralBalance: referralBalanceResponse });
			})
			.catch(err => {
				throw err;
			});
	},
	updateRemainingReferrals: (customerId: string, remainingReferrals: number) => (dispatch: any) => {
		return userAPI.updateRemainingReferrals(customerId, remainingReferrals)
			.then((remainingReferralsResponse: number) => {
				dispatch({ type: actionTypes.UPDATE_REMAINING_REFERRALS_SUCCESS, remainingReferrals: remainingReferralsResponse });
			})
			.catch(err => {
				throw err;
			});
	},
	updateCustomerReferralEnabled: (customerId: string) => (dispatch: any) => {
		return userAPI.updateCustomerReferralEnabled(customerId)
			.then((referralEnabledResponse: boolean) => {
				dispatch({ type: actionTypes.UPDATE_REFERRAL_ENABLED_SUCCESS, referralEnabled: referralEnabledResponse});
			})
			.catch(err => {
				throw err;
			});
	},
	setCustomerReferralBalance: (referralBalance: number) => {
		return (dispatch: any) => {
			dispatch({ type: actionTypes.SET_CUSTOMER_REFERRAL_BALANCE, referralBalance });
			return Promise.resolve();
		};
	},
	setCustomerRemainingReferrals: (remainingReferrals: number) => {
		return { type: actionTypes.SET_CUSTOMER_REMAINING_REFERRALS, remainingReferrals };
	},
	sendReferralInviteEmail: (userId: string, name: string, email: string) => (dispatch: any) => {
		return userAPI.sendReferralInviteEmail(userId, name, email)
			.then((success: boolean) => {
				dispatch({ type: actionTypes.SEND_REFERRAL_INVITE_EMAIL_SUCCESS, success });
			})
			.catch(err => {
				throw err;
			});
	},
	sendSpousalReferralInviteEmail: (userId: string, name: string, email: string) => (dispatch: any) => {
		return userAPI.sendSpousalReferralInviteEmail(userId, name, email)
			.then((success: boolean) => {
				dispatch({ type: actionTypes.SEND_REFERRAL_INVITE_EMAIL_SUCCESS, success });
			})
			.catch(err => {
				throw err;
			});
	},
	sendSoftDeclinedEmail: (userId: string) => (dispatch: any) => {
		return userAPI.sendSoftDeclinedEmail(userId)
			.then((success: boolean) => {
				dispatch({ type: actionTypes.SEND_SOFT_DECLINED_EMAIL_SUCCESS, success});
			})
			.catch(err => {
				throw err;
			});
	},

	updateStripeCustomerEmail: (customerId: string, email: string) => (dispatch: any) => {
		return userAPI.updateStripeCustomerEmail(customerId, email)
			.then(updatedCustomerResponse => {
				dispatch({ type: actionTypes.UPDATE_CUSTOMER_EMAIL, user: updatedCustomerResponse });
			})
			.catch(err => {
				if (err.responseStatus) {
					toastr.error(err.responseStatus.message);
				}
			});
	},
};

export default userActions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/user/userActions.ts